import { connect } from "react-redux";
import PropTypes from "prop-types";

import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField, CheckField, TextArea } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import { hideModal } from "../utils/domUtils";
import { removeNullProperties } from "../utils/jsonUtils";

import { createClient } from "../actions/clientActions";

class AdminAddClientModal extends BaseInputComponent {
  modal_id = "modal_add_client";

  state = {
    name: "",
    email: "",
    code: "",
    phone: "",
    address: "",
    user: "",
    password: "",
    is_active: true,
    is_verified: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.client.loadingOperation;
  }

  onAcceptClick = () => {
    const {
      user,
      email,
      name,
      phone,
      code,
      address,
      password,
      is_active,
      is_verified,
    } = this.state;

    // @ts-ignore
    this.props.createClient(
      {
        user,
        email,
        name,
        phone,
        code: code.trim().length > 0 ? code : null,
        address,
        password,
        is_active,
        is_verified,
      },
      (success) => {
        if (!success) return;

        this.clearForm();
        this.onCancelClick();
      }
    );
  };

  clearForm = () => {
    this.setState({
      name: "",
      email: "",
      code: "",
      phone: "",
      address: "",
      user: "",
      password: "",
      is_active: true,
      is_verified: false,
    });
  };

  onCancelClick = () => {
    hideModal(this.modal_id);
  };

  getForm = () => {
    const {
      user,
      email,
      name,
      phone,
      code,
      address,
      password,
      is_active,
      is_verified,
      errors,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="name"
            value={name}
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="code"
            value={code}
            label="Codigo de cliente"
            placeholder="Autogenerado"
            error={errors}
            onChange={this.onChangeTextInput}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="phone"
            value={phone}
            label="Telefono"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="email"
            value={email}
            label="Correo"
            error={errors}
            type="email"
            onChange={this.onChangeTextInput}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="user"
            value={user}
            label="Nombre de usuario"
            placeholder="Opcional"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="password"
            value={password}
            label="Clave"
            error={errors}
            onChange={this.onChangeTextInput}
            type="password"
          />
        </div>

        <TextArea
          id="address"
          value={address}
          label="Direcci&oacute;n de envio (opcional)"
          error={errors}
          onChange={this.onChangeTextInput}
        />

        <div className="grid-2-col form-row">
          <CheckField
            id="is_active"
            label="Activo"
            checked={is_active}
            onChange={this.onChangeCheckField}
            error={errors}
          />

          <CheckField
            id="is_verified"
            label="Verificado"
            checked={is_verified}
            onChange={this.onChangeCheckField}
            error={errors}
          />
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crear nuevo cliente</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminAddClientModal.propTypes = {
  client: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  createClient: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  client: state.client,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  createClient,
})(AdminAddClientModal);
